import React, { useState } from 'react';
import { BASE_URL } from '../config/api'; // Ensure BASE_URL is defined in your config/api.js
import { useNavigate } from 'react-router-dom';

const AddRodiums = () => {
    const [staffId, setStaffId] = useState(1); // Default or static staff ID
    const [customerName, setCustomerName] = useState('');
    const [pcs, setPcs] = useState('');
    const [description, setDescription] = useState('');
    const navigate = useNavigate();

    const handleSubmit = (event) => {
        event.preventDefault();

        const rodiumData = {
            staff_id: staffId,
            customer_name: customerName,
            pcs: pcs,
            description: description,
        };

        fetch(`${BASE_URL}rodiums`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(rodiumData),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    navigate('/RodiumsList');
                } else {
                    console.error('Error creating rodium entry:', data.message);
                }
            })
            .catch(error => console.error('Error:', error));
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Rodium</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h4>Enter Rodium Details</h4>
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={() => navigate('/RodiumsList')}>Back to List</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="staffId" className="form-label">Staff ID</label>
                                        <input
                                            type="number"
                                            id="staffId"
                                            className="form-control"
                                            value={staffId}
                                            onChange={(e) => setStaffId(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="customerName" className="form-label">Customer Name</label>
                                        <input
                                            type="text"
                                            id="customerName"
                                            className="form-control"
                                            value={customerName}
                                            onChange={(e) => setCustomerName(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="pcs" className="form-label">PCS</label>
                                        <input
                                            type="number"
                                            id="pcs"
                                            className="form-control"
                                            value={pcs}
                                            onChange={(e) => setPcs(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <textarea
                                            id="description"
                                            className="form-control"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                        ></textarea>
                                    </div>
                                    <div className="text-end">
                                        <button type="submit" className="btn btn-success">Save Rodium</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddRodiums;
